const productGalleryNavMixin = {

    created() {
        // Set data
        this.metrics = [];
        this.navIndex = 0;
        this.lastHoverIndex = -1;
    },

    methods: {
        updateGalleryNav() {
            // UI
            this.$galleryBtns = this.$refs.galleryBtnItem;

            if (!this.$galleryBtns) return

            // Set metrics
            this.setMetrics();

            // Set Index
            this.setDefaultValues(0);
        },

        setMetrics() {
            this.metrics = [];

            this.$galleryBtns.forEach(($btn) => {
                this.metrics.push($btn.offsetHeight);
            });
        },

        setNavIndex(index) {
            if (index === this.navIndex) return
            this.navIndex = index;
            this.setDefaultValues(index);
        },

        setDefaultValues(index) {
            this.computeTranslateY(index);
        },

        onNavClick(index) {
            this.swiperInstance?.slideTo?.(index);
            this.setNavIndex(index);
        },

        onNavMouseEnter(index) {
            this.computeTranslateY(index);
            this.lastHoverIndex = index;
        },

        onNavMouseLeave() {
            this.setDefaultValues(this.navIndex >= 0 ? this.navIndex : this.lastHoverIndex);
        },

        computeTranslateY(index) {
            if (index < 0) return;
            const metrics = [...this.metrics];
            metrics.length = index;
            const translateY = metrics.reduce((a, b) => a + b, 0);
            this.$refs.galleryNav?.style.setProperty("--indicatorTranslateY", `${translateY}px`);
        },

        onNavResize() {
            if (!this.$galleryBtns) return

            this.setMetrics();
            this.setDefaultValues(this.navIndex);
        }
    }
}

export default productGalleryNavMixin;
